module.exports = __webpack_public_path__ + "static/apahm-2017-e3f297bffc395fe63940aa387be161a8.jpg";